import { Badge } from "@marekl/adminer/components";
import type { DocumentStatus } from "../../lib/queries/documents";

export function StatusBadge({ status }: { status: DocumentStatus }) {
  return status === "issued" ? (
    <Badge weight="ghost" variant="ok" dot>Vystaveno</Badge>
  ) : (
    <Badge weight="ghost" variant="warn" dot>Koncept</Badge>
  );
}
